/**
 * Dark/Light Mode Toggle
 * Uses localStorage to persist user preference
 */

(function() {
    'use strict';

    const STORAGE_KEY = 'contelizer-theme-mode';
    const DARK_CLASS = 'dark'; // Tailwind uses 'dark' class

    /**
     * Get saved theme from localStorage or default to light
     */
    function getSavedTheme() {
        return localStorage.getItem(STORAGE_KEY) || 'light';
    }

    /**
     * Save theme to localStorage
     */
    function saveTheme(theme) {
        localStorage.setItem(STORAGE_KEY, theme);
    }

    /**
     * Apply theme to document
     */
    function applyTheme(theme) {
        const html = document.documentElement;

        if (theme === 'dark') {
            html.classList.add(DARK_CLASS);
        } else {
            html.classList.remove(DARK_CLASS);
        }
    }

    /**
     * Toggle between dark and light themes
     */
    function toggleTheme() {
        const currentTheme = getSavedTheme();
        const newTheme = currentTheme === 'dark' ? 'light' : 'dark';

        saveTheme(newTheme);
        applyTheme(newTheme);

        // Update all toggle buttons
        updateToggleButtons(newTheme);
    }

    /**
     * Update toggle button states
     */
    function updateToggleButtons(theme) {
        const toggles = document.querySelectorAll('.theme-toggle');
        toggles.forEach(toggle => {
            const icon = toggle.querySelector('.theme-toggle-icon');
            if (icon) {
                if (theme === 'dark') {
                    icon.innerHTML = '<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"></path></svg>';
                    toggle.setAttribute('aria-label', 'Switch to light mode');
                } else {
                    icon.innerHTML = '<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"></path></svg>';
                    toggle.setAttribute('aria-label', 'Switch to dark mode');
                }
            }
        });
    }

    /**
     * Initialize theme on page load
     */
    function init() {
        const savedTheme = getSavedTheme();
        applyTheme(savedTheme);

        // Wait for DOM to be ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                updateToggleButtons(savedTheme);
                attachEventListeners();
            });
        } else {
            updateToggleButtons(savedTheme);
            attachEventListeners();
        }
    }

    /**
     * Attach event listeners to toggle buttons
     */
    function attachEventListeners() {
        const toggles = document.querySelectorAll('.theme-toggle');
        toggles.forEach(toggle => {
            toggle.addEventListener('click', toggleTheme);
        });
    }

    // Initialize immediately to avoid flash
    init();

    // Expose toggle function globally for inline usage
    window.contelizerToggleTheme = toggleTheme;
})();
